import React from 'react';
import { Box, Grid, Skeleton, Card, CardContent } from '@mui/material';

/**
 * Skeleton loader for Dashboard page
 * Displays animated metric cards while dashboard data is loading
 */
export const DashboardSkeleton: React.FC = () => {
  return (
    <Box>
      {/* Header */}
      <Skeleton data-testid="dashboard-skeleton-line" variant="text" width={200} height={48} sx={{ mb: 3 }} />

      {/* Metric Cards Row 1 */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        {Array.from({ length: 4 }).map((_, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card>
              <CardContent>
                <Skeleton data-testid="dashboard-skeleton-line" variant="text" width="60%" height={24} sx={{ mb: 1 }} />
                <Skeleton data-testid="dashboard-skeleton-line" variant="text" width="80%" height={40} sx={{ mb: 1 }} />
                <Skeleton data-testid="dashboard-skeleton-line" variant="text" width="40%" height={20} />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Metric Cards Row 2 */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        {Array.from({ length: 4 }).map((_, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card>
              <CardContent>
                <Skeleton data-testid="dashboard-skeleton-line" variant="text" width="70%" height={24} sx={{ mb: 1 }} />
                <Skeleton data-testid="dashboard-skeleton-line" variant="text" width="50%" height={36} />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Charts Row */}
      <Grid container spacing={3}>
        {Array.from({ length: 2 }).map((_, index) => (
          <Grid item xs={12} md={6} key={index}>
            <Card>
              <CardContent>
                <Skeleton data-testid="dashboard-skeleton-line" variant="text" width="50%" height={32} sx={{ mb: 2 }} />
                <Skeleton data-testid="dashboard-skeleton-rect" variant="rectangular" width="100%" height={250} />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
